import React, { useState } from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
function FixedValueSlider(props) {

    const [value, setValue] = useState(props.defaultVal); // Initial value

    const handleValueChange = (newValue) => {
        setValue(newValue);
        props.amountSpreadForce(newValue);
        props.nbrMaxSpreadForce(props.listNbrSpread[Math.round(newValue)]);
        props.parentFunction();
    };


    return (
        <>
        <label className="montant-partiel col-12"><b>Montant du paiement instantané : {value} &euro;</b></label>
            <div className={"slider-et col-10"}>
                <Slider
                    disabled={props.amountvalid}
                    min={props.minVal}
                    max={props.maxVal}
                    step={null} // null step to snap to fixed values
                    defaultValue={props.defaultVal}
                    onChange={handleValueChange}
                    marks={props.listValueAmount.reduce((marks, value) => {
                    marks[value] = value.toString(); // Convert numbers to strings for display
                    return marks;
                }, {})}/>
            </div>
        </>
    );
};

export default FixedValueSlider;
